import React from 'react';
import { CustomHeader } from '../components/CustomHeaderComponent/customHeader';
import {
  ApproveOrRejectComponent,
  TextComponent
} from '../components/TableComponents';
import {
  TM_FRAUD_SOURCE_IDS,
  TM_FRAUD_PREVENTION_SOURCE_MAPPING
} from '../../../util/GlobalConstant';
import { isResourceAvailable } from '../../../util';
import { convertISOToDateFormat } from '../../../util/timezone';
import style from './index.scss';
import { getSelectedResources } from '../../../util/resourceManager';

const { trmResources } = getSelectedResources();

export const dashboardColumns = ({ authentication, history, onAction }) => {
  const APPROVE_REJECT_ACTIONS_ACCESS = isResourceAvailable(
    { data: authentication },
    trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET
  );

  const isUserAllowedIdClick = isResourceAvailable(
    { data: authentication },
    trmResources.APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS
  );

  const detectionColumns = [
    {
      title: <CustomHeader title={'ID'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => {
        return (
          <TextComponent
            style={{ color: '#0C8ED7', maxWidth: '100px' }}
            id={runInstance.id}
          />
        );
      }
    },
    {
      title: <CustomHeader title={'Challenger Name'} />,
      className: style.bgWhite,
      key: 'runInstance',
      // ticket detail page navigation
      onCell: (record, rowIndex) => {
        return {
          onClick: (event) => {
            if (isUserAllowedIdClick) {
              history.push(
                `/app/trm/ticketDetails/${record.id}?sourceId=${record.sourceId}`
              );
            }
          }
        };
      },
      render: (runInstance) => {
        const notAllowedStyles = {
          color: '#000',
          maxWidth: '200px'
        };
        return (
          <TextComponent
            className={style.ellipsisBlock}
            style={
              isUserAllowedIdClick
                ? { color: '#0C8ED7', maxWidth: '200px', cursor: 'pointer' }
                : notAllowedStyles
            }
            id={runInstance.challengerName}
            showTooltip
          />
        );
      }
    },
    {
      title: <CustomHeader title={'Item Type'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ fontWeight: '500', fontSize: '12px', maxWidth: '120px' }}
          id={runInstance.requestType}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'FinCrime Type'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          id={
            runInstance?.sourceId === parseInt(TM_FRAUD_SOURCE_IDS.TM)
              ? TM_FRAUD_PREVENTION_SOURCE_MAPPING.TM_AML
              : runInstance?.sourceId ===
                parseInt(TM_FRAUD_SOURCE_IDS.FRAUD_PREVENTION_ID)
              ? TM_FRAUD_PREVENTION_SOURCE_MAPPING.FRAUD_PREVENTION
              : TM_FRAUD_PREVENTION_SOURCE_MAPPING.FRAUD_DETECTION
          }
        />
      )
    },
    {
      title: <CustomHeader title={'Run Instance Name'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ maxWidth: '200px' }}
          id={runInstance.scenarioName}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'Typology/Variant Count'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          id={runInstance?.numTypology ? runInstance.numTypology : '-'}
        />
      )
    },
    {
      title: <CustomHeader title={'Creator'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ maxWidth: '120px' }}
          id={runInstance.createdBy}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'Creation Date'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent id={convertISOToDateFormat(runInstance.createdAt)} />
      )
    }
  ];

  const preventionColumns = [
    {
      title: <CustomHeader title={'ID'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => {
        return (
          <TextComponent
            style={{ color: '#0C8ED7', maxWidth: '100px' }}
            id={runInstance.id}
          />
        );
      }
    },
    {
      title: <CustomHeader title={'Challenger Name'} />,
      className: style.bgWhite,
      key: 'runInstance',
      // ticket detail page navigation
      onCell: (record, rowIndex) => {
        return {
          onClick: (event) => {
            if (isUserAllowedIdClick) {
              history.push(
                `/app/trm/ticketDetails/${record.id}?sourceId=${record.sourceId}&scheduled=${record.scheduled}`
              );
            }
          }
        };
      },
      render: (runInstance) => {
        const notAllowedStyles = {
          color: '#000',
          maxWidth: '184px'
        };
        return (
          <TextComponent
            className={style.ellipsisBlock}
            style={
              isUserAllowedIdClick
                ? { color: '#0C8ED7', maxWidth: '184px', cursor: 'pointer' }
                : notAllowedStyles
            }
            id={runInstance.challengerName}
            showTooltip
          />
        );
      }
    },
    {
      title: <CustomHeader title={'Item Type'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ fontWeight: '500', fontSize: '12px', maxWidth: '112px' }}
          id={runInstance.requestType}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'FinCrime Type'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          id={TM_FRAUD_PREVENTION_SOURCE_MAPPING.FRAUD_PREVENTION}
        />
      )
    },
    {
      title: <CustomHeader title={'Scheduled'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent id={runInstance.scheduled ? 'Yes' : 'No'} />
      )
    },
    {
      title: <CustomHeader title={'Run Instance Name'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ maxWidth: '184px' }}
          id={runInstance.scenarioName}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'Typology/Variant Count'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          id={runInstance?.numTypology ? runInstance.numTypology : '-'}
        />
      )
    },
    {
      title: <CustomHeader title={'Creator'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent
          className={style.ellipsisBlock}
          style={{ maxWidth: '112px' }}
          id={runInstance.createdBy}
          showTooltip
        />
      )
    },
    {
      title: <CustomHeader title={'Creation Date'} />,
      className: style.bgWhite,
      key: 'runInstance',
      render: (runInstance) => (
        <TextComponent id={convertISOToDateFormat(runInstance.createdAt)} />
      )
    }
  ];

  const action = {
    title: <CustomHeader title={'Action'} />,
    className: style.bgWhite,
    key: 'runInstance',
    render: (runInstance) => (
      <ApproveOrRejectComponent
        showLinks
        ticket={runInstance}
        onAction={onAction}
        authentication={authentication}
      />
    )
  };

  if (APPROVE_REJECT_ACTIONS_ACCESS) {
    return {
      detectionColumns: [...detectionColumns, action],
      preventionColumns: [...preventionColumns, action]
    };
  }

  return {
    detectionColumns,
    preventionColumns
  };
};
